module.exports = __webpack_public_path__ + "static/img/8.90ab48f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tiankeng/8.jpg
// module id = 6asN
// module chunks = 1